<header class="header">
  <div class="header-content">
    <div class="welcome-text">
      <img *ngIf="isCorporateModule() && logoUrl" [src]="logoUrl" alt="Logo" class="corporate-logo rounded-md">
    </div>
    <div class="header-actions">
      <div class="user-controls">
        <button 
          class="notifications relative group cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-100 rounded-md p-1" 
          (click)="navigateToNotifications()"
          (keydown.enter)="navigateToNotifications()"
          (keydown.space)="$event.preventDefault(); navigateToNotifications()"
          tabindex="0"
          aria-label="Notifications">
          <i class="bi bi-bell"></i>
          <span class="tooltip-text group-hover:opacity-100">Notifications</span>
          <span
            *ngIf="unreadCount > 0"
            class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium">
            {{ unreadCount > 99 ? '99+' : unreadCount }}
          </span>
        </button>
        <div class="module-type" [class.cursor-pointer]="isProfileClickable()" (click)="navigateToProfile()">
          <span class="module-name">{{ getModuleType() }}</span>
        </div>
        <div class="relative group">
          <button class="" (click)="logout()">
            <i class="bi bi-box-arrow-right"></i>
          </button>
          <span class="tooltip-text group-hover:opacity-100">Logout</span>
        </div>
      </div>
    </div>
  </div>
</header>


